import { ShieldCheck } from 'lucide-react';

import { cx } from './cx';

/**
 * What the embeddable badge looks like. The published badge is an image the
 * API renders (PublicBadge.imageUrl); this is the same design in HTML, for
 * previews where there is no audit yet.
 */
export function BadgePreview({
  className,
  domain,
  monthYear,
  standard,
}: {
  className?: string;
  domain?: string;
  monthYear: string;
  standard: string;
}) {
  return (
    <div
      className={cx(
        'inline-flex items-center gap-3 rounded-button border border-hairline-alt bg-surface py-2.5 pl-3 pr-4 shadow-soft',
        className,
      )}
    >
      <span className="flex size-9 shrink-0 items-center justify-center rounded-button bg-ink text-white">
        <ShieldCheck aria-hidden size={20} strokeWidth={1.75} />
      </span>
      <span className="flex flex-col leading-tight">
        <span className="text-ui-strong font-semibold text-text-primary">
          Accessibility audited by Floto
        </span>
        <span className="text-caption text-text-secondary">
          {standard} · {monthYear}
          {domain ? ` · ${domain}` : ''}
        </span>
      </span>
    </div>
  );
}
